/**
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//入库单列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/storageBill/list`, {
    method: 'post',
    body: param,
  });
}
//新增入库单
export function add(param) {
  /*
   param: {
   billNo (string, optional): 入库单号 ,
   localId (integer, optional): 货位id ,
   remark (string, optional): '备注 ,
   storageBillProduct (Array[DmsStorageBillProduct], optional): 产品列表 ,
   storageId (integer, optional): 仓库id ,
   type (integer, optional): 入库类型（1-采购入库；2-其它入库）
   }

   DmsStorageBillProduct: {
   id (integer, optional): 主键id ,
   productId (integer, optional): 产品id ,
   specName (string, optional): 规格名称 ,
   storageNum (integer, optional): 入库数量 ,
   unit (integer, optional): 单位 ,
   }
  * */
  return request(`${config.server}/api/v1/dms/storageBill/save`, {
    method: 'post',
    body: param,
  });
}
//修改入库单
export function update(param) {
  /*
   param: {
   billNo (string, optional): 入库单号 ,
   id (integer, optional): 主键ID ,
   localId (integer, optional): 货位id ,
   remark (string, optional): '备注 ,
   storageBillProduct (Array[DmsStorageBillProduct], optional): 产品列表 ,
   storageId (integer, optional): 仓库id ,
   type (integer, optional): 入库类型（1-采购入库；2-其它入库）
   }

   DmsStorageBillProduct: {
   id (integer, optional): 主键id ,
   productId (integer, optional): 产品id ,
   specName (string, optional): 规格名称 ,
   storageBillId (integer, optional): 入库单id ,
   storageNum (integer, optional): 入库数量 ,
   unit (integer, optional): 单位 ,
   }
   * */
  return request(`${config.server}/api/v1/dms/storageBill/update`, {
    method: 'post',
    body: param,
  });
}

export const exportFun = `${config.server}/api/v1/dms/storageBill/exportBill`;


// WEBPACK FOOTER //
// ./src/service/inventory/entry.js